import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import MerchantProvider  from "../src/Components/Common/Context/MerchantContext"
import "./index.css";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <MerchantProvider>
      <App />
    </MerchantProvider>
  </BrowserRouter>
);

reportWebVitals();
